/**
 * Strip leading entity YAML frontmatter from a Database entry, returning the
 * prose body. Mirrors `strip_entity_frontmatter` in
 * `src-tauri/src/entity_frontmatter.rs` (including the two-pass repair for the
 * brief double-frontmatter window) — TS only needs the body; fields come from
 * the typed list/get IPC commands.
 */
export function stripEntityFrontmatterBody(raw: string): string {
  let body = raw;
  for (let i = 0; i < 2; i++) {
    if (body.startsWith("---\n") === false) break;
    const rest = body.slice("---\n".length);
    const end = rest.indexOf("\n---\n");
    if (end < 0) break;
    body = rest.slice(end + "\n---\n".length);
  }
  return body;
}
